import React from 'react'
import SimpleStepNav from '../navigation/SimpleStepNav'
import InputRadioBox from '../inputs/InputRadioBox'
import InputWrapper from '../inputs/InputWrapper'
import InputDefault from '../inputs/InputDefault'
import WhenCondition from '../misc/WhenCondition'
import usePortManager from '../hooks/use-port-manager'
import { observer } from 'mobx-react'
import FormHeader from '../inputs/FormHeader'
import useNavigationManager from '../hooks/use-navigation-manager'
import useSettingsManager from '../hooks/use-settings-manager'
import CalculateRoofAngle from '../misc/CalculateRoofAngle'
import ValidationError from '../inputs/ValidationError'
import OtherOptionWysisygContent from '../misc/OtherOptionWysisygContent'

const RailsType = observer(function RailsType () {
  const manager = usePortManager()
  const settings_manager = useSettingsManager()
  const value = manager.getValue('rails_type')
  const optionSettings = settings_manager.getInputOptionSettings(
    'rails_type',
    value
  )
  const inputOptionSettings =
    typeof optionSettings === 'object' ? optionSettings : { title: value }
  const settings = settings_manager.getInputSettings('rails_type')
  const inputSettings =
    typeof settings === 'object' ? settings : { title: value }
  const title =
    typeof inputOptionSettings.title === 'string'
      ? inputOptionSettings.title
      : null
  const description =
    typeof inputOptionSettings.description === 'string' ? (
      <p>{inputOptionSettings.description}</p>
    ) : null
  return (
    <aside className="input-wrapper">
      <div className="input-header input-header_margin-even">
        <h2>
          {inputSettings.title}: {title}
        </h2>{' '}
        {description}
      </div>
    </aside>
  )
})

const Lift = observer(() => {
  let portManager = usePortManager()
  let upperHeight = Number(portManager.getValue('upper_height'))
  let portHeight = Number(portManager.getValue('height'))
  let totalHeight = upperHeight + portHeight
  const settings_manager = useSettingsManager()
  const _settings = settings_manager.getInputSettings('rent_lift')
  let liftRequiredHeight = _settings?.max_height ?? 500
  return (
    <WhenCondition condition={'greater'} arg={[totalHeight, liftRequiredHeight]}>
      <InputWrapper name={'rent_lift'}>
        <InputRadioBox value={'no'} size={'half'}/>
        <InputRadioBox value={'yes'} size={'half'}/>
      </InputWrapper>
    </WhenCondition>
  )
})

function RailsStep () {
  const nav_manager = useNavigationManager()
  const settings_manager = useSettingsManager()
  const step_index = 2
  const step_name = nav_manager.getStepName(step_index)
  const strings = settings_manager.getStepSettings(step_name)

  const manager = usePortManager()

  const min = manager.currentPort.model === '9000' ? 20 : 50

  if (typeof manager.currentPort.rails_type === 'undefined') {
    manager.updateValue('rails_type', 'standard')
  }

  return (
    <React.Fragment>
      <FormHeader htag={'h1'} strings={strings}/>

      <InputWrapper name={'upper_height'}>
        <InputDefault type={'number'} min={min} max={300} name={'upper_height'}/>
        <ValidationError>
          <WhenCondition
            condition={'equals'}
            arg={[manager.currentPort.model, '9000']}
          >
            <OtherOptionWysisygContent name={'ve_upper_height_9000'}/>
          </WhenCondition>
          <WhenCondition
            condition={'equals'}
            arg={[manager.currentPort.model, '8000']}
          >
            <OtherOptionWysisygContent name={'ve_upper_height_8000'}/>
          </WhenCondition>
          <OtherOptionWysisygContent name={'ve_upper_height_always'}/>
        </ValidationError>
      </InputWrapper>

      <RailsType/>

      <Lift/>

      <InputWrapper name={'roof_has_angle'}>
        <InputRadioBox value={'no'} size={'half'}/>
        <InputRadioBox value={'yes'} size={'half'}/>
      </InputWrapper>

      <WhenCondition condition={'hasRoofAngle'}>
        <InputWrapper
          name={'roof_angle'}
          borderless={true}
          grid={null}
          htag={'h3'}
          className={'input-wrapper input-wrapper--calculate'}
        >
          <CalculateRoofAngle/>
          <InputDefault type={'number'} min={0} max={20} name={'roof_angle'}/>
          <ValidationError>
            <OtherOptionWysisygContent name={'ve_roof_angle'}/>
          </ValidationError>
        </InputWrapper>
      </WhenCondition>

      <SimpleStepNav step_name={step_name}/>
    </React.Fragment>
  )
}

export default observer(RailsStep)
